<tabs-inner-wrap>
  @if (isLoading()) {
    <div class="loading-container">
      <qai-loading [size]="'medium'"></qai-loading>
    </div>
  }

  @if (!isLoading() && simulations().length === 0) {
    <div class="empty-card">
      <span>{{ labels.noSimulations }}</span>
    </div>
  }

  @if (!isLoading()) {
    <div class="simulations-container">
      <qai-dragable
        #dragable
        [items]="simulations()"
        (itemsChange)="onSimulationsChange($event)"
        [useDragHandle]="true"
        [dragHandleDisable]="isCompleted()"
      >
        <ng-template #cardTemplate let-item>
          <div class="sim-card-wrapper">

            <qai-simulation-card
              [title]="item.callName"
              [callType]="item.callType"
              [description]="item.description"
              [disabled]="isCompleted()"
              [attemptsCurrentValue]="item.numberOfAttemptsAllowed + ''"
              [avatarImageSrc]="item.thumbnailForCall"
              [showAttemptsAllowed]="showAttemptsAllowed()"
              [showRandomization]="item.callType === 'GUIDED'"
              [showTrashButton]="true"
              [strategyOptions]="strategyOptions"
              [countSelectOptions]="countSelectOptions"
              [randomizationState]="getRandomState(item.callUuid)"
              [randomizationLabels]="randomizationLabels"
              (attemptsSelected)="setSelectedCard(item); onAttemptsSelected($event)"
              (strategyChange)="onStrategyChange(item, $any($event))"
              (countChange)="onCountChange(item, $any($event))"
              (poolBlur)="onPoolBlur(item, $event)"
              (removeLinkClick)="removeLinkClick(item)"
              (opened)="dragable.onDropdownOpen()"
              (closed)="dragable.onDropdownClose()"
            >
            </qai-simulation-card>

          </div>
        </ng-template>
      </qai-dragable>
    </div>
  }

  <div class="add-simulation-btn">
    <button
      qai-button
      [shape]="'normal'"
      [kind]="'primary'"
      [size]="'medium'"
      (click)="openAddSimulationModal()"
      [disabled]="isCompleted()"
    >
      <qai-icon kind="plus" positionStart />
      {{ labels.addSimulation }}
    </button>
  </div>
</tabs-inner-wrap>

<add-simulation-to-assignment-modal
  [open]="addSimulationsToAssignmentModalOpen()"
  (closeSimulationModal)="closeAssignmentModal()"
  [moduleAssignmentUuid]="moduleAssignmentUuid"
  [moduleUuid]="moduleUuid"
  (simulationAssigned)="closeModalAndReloadSimulations()"
  [isCreateAssignmentFlow]="false"
></add-simulation-to-assignment-modal>
